import { useParams } from "react-router-dom";

import { ModelType } from "../../../API";
import SecurityEventsServerTableContainer from "../../telemetry/models/security/SecurityEventsServerTableContainer";
import FireEventsServerTableContainer from "./models/fire/FireEventsServerTableContainer";
import GasLeakTableServerContainer from "./models/gasleak/GasLeakTableServerContainer";
import GateGuardServerTableContainer from "./models/gateGuard/GateGuardServerTableContainer";
import LiquidLeakServerTableContainer from "./models/liquidleak/LiquidLeakServerTableContainer";
import SmokeEventsServerTableContainer from "./models/smoke/SmokeEventsServerTableContainer";
import TlmEventsServerTableContainer from "./models/tlm/TlmEventsServerTableContainer";

const DataHubPageContent = (): JSX.Element => {
  const { model } = useParams();

  let content = <></>;

  switch (model) {
    case "gasleak":
      content = <GasLeakTableServerContainer />;
      break;
    case "liquidleak":
      content = <LiquidLeakServerTableContainer />;
      break;
    case "fire":
      content = <FireEventsServerTableContainer />;
      break;
    case "smoke":
      content = <SmokeEventsServerTableContainer />;
      break;
    case "agg":
      content = <GateGuardServerTableContainer />;
      break;
    case ModelType.peopleandvehicle:
      content = <SecurityEventsServerTableContainer />;
      break;

    case "tlm":
      content = <TlmEventsServerTableContainer />;
      break;

    default:
      break;
  }

  return content;
};

export default DataHubPageContent;
